import { CustomFieldEntity, CustomFieldEntityItem } from 'shared'
import { toLabeledValues as to } from '../../../utils/labeledValues'
import { CTS, CustomFieldEntityRecordType, FDC } from './types'
import { SEPARATOR } from '../../types'
import { DefaultOptionType } from '../../../types'

export function toLabeledValues(
  items: CustomFieldEntityRecordType[] | undefined | null
) {
  return to(items, {
    type: 'callback',
    callback: (item) => {
      const value =
        item.__typename === 'ConcreteTestSet'
          ? item.globalId
          : (item as Exclude<CustomFieldEntityRecordType, CTS>).id
      const label =
        item.__typename === 'ConcreteTestSet'
          ? item.testSetId
          : item.__typename === 'FieldDesignChange'
          ? item.number
          : (item as Exclude<CustomFieldEntityRecordType, CTS | FDC>)
              .sharePointFolderName
      const { id } =
        (item.__typename &&
          CustomFieldEntity.fromClassTypeOrFail(item.__typename)) ??
        {}
      return { label, value: `${id}${SEPARATOR}${value}` }
    },
  })
}

export function split(value: DefaultOptionType['value']) {
  const [itemId, globalIdOrId] =
    (value?.toString().split(SEPARATOR) as [
      CustomFieldEntityItem['id'],
      string
    ]) ?? []
  if (itemId === CustomFieldEntity.CAS.id)
    return { constructionAdminSubmittalId: globalIdOrId }
  else if (itemId === CustomFieldEntity.CTS.id)
    return { concreteTestSetGlobalId: globalIdOrId }
  else if (itemId === CustomFieldEntity.DS.id)
    return { designSubmittalId: globalIdOrId }
  else if (itemId === CustomFieldEntity.FDC.id)
    return { fieldDesignChangeId: globalIdOrId }
  return undefined
}
